import styled from "styled-components"

export const StyledIconContainer = styled.div`
    background-color: #fff;
    color: ${({color}) => color};
`

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`

export const Card = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 320px;
    height: 135px;
    background-color: #fff;
    border-radius: 10px;
    padding: 24px;
`

export const CardBody = styled.div`
    display: flex;
    gap: 14px;
    justify-content: center;
`

export const TextDiv = styled.div`
    font-family: Hind Vadodara, Lucida Sans Unicode !important;
    letter-spacing: 0.8px;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.3;
    color: #acb4b9;
    display: flex;
    align-items: center;
    justify-content: left;
    text-align: left;
`